import React, { Component, Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter } from "common/utils/router.util";
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
} from '@mui/material';
import {
  DashboardOutlined as DashboardIcon,
  PeopleOutlined as PeopleIcon,
  ShoppingBasketOutlined as ShoppingBasketIcon,
  LockOpenOutlined as LockOpenIcon,
  TextFields as TextFieldsIcon,
  ImageOutlined as ImageIcon,
  InfoOutlined as InfoIcon,
  AccountBoxOutlined as AccountBoxIcon,
  SettingsOutlined as SettingsIcon,
  Search as SearchIcon,
  Money as MoneyIcon,
  ContactSupport as ContactSupportIcon,
  Flag as FlagIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Home as HomeIcon,
  Input as InputIcon,
  Person as PersonIcon,
  CalendarToday,
  CreditCard as CreditCardIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  AddComment as FeedbackIcon,
  Adjust as AdjustIcon,
  Highlight as HighlightIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';
import styles from "./styles";
import { IsValidLoginAuth, IsValidSemiAuth } from "common/storage";
import compose from "recompose/compose";
import Base from "common/constants";
import { connect } from "react-redux";
import { GetStateStorage, IsValidNavbarData } from "common/storage";
import HelpV1Wrapper from "views/Help/HelpV1Wrapper.jsx";
import { isUserAdmin, isUserAgent } from "common/roles/role.js";
import { isAKylesAccount } from "common/helpers";
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    /** check for auth */
    this.isValidLogin = IsValidLoginAuth();
    this.isValidSemiLogin = IsValidSemiAuth();
  }

  handleSignOut = () => {
    const { history } = this.props;

    //localStorage.setItem('isAuthenticated', false);
    //ResetAllLocalStorages();
    history.push("/logout?mode=1");
  };

  isPathActive = (path) => {
    const { location } = this.props;
    if (!location || !path) {
      return false;
    }
    const currentPath = location.pathname || "";
    return currentPath === path || currentPath.startsWith(`${path}/`);
  };

  render() {
    const {
      classes,
      className,
      handleDrawerClose,
      localStateData,
    } = this.props;
    const stateData = GetStateStorage();
    const agentData = (stateData || {}).userData;
    let navbarData =
      agentData && Array.isArray(agentData.navbarInfo)
        ? agentData.navbarInfo[0]
        : {};
    const primaryAreaId = navbarData && navbarData.mlsAreaID;
    const viewPmaPath = primaryAreaId ? `/pma/${primaryAreaId}` : "/pma";
    const viewMailProPath = primaryAreaId ? `/mailpro/${primaryAreaId}` : "/mailpro";
    const encodedLocalUserId =
      localStateData && localStateData.userID ? btoa(localStateData.userID) : null;
    const encodedNull = btoa(null);
    const updateProfilePath = encodedLocalUserId
      ? `/agent/details/ag/${encodedLocalUserId}`
      : "";
    const manageCardsPath = encodedLocalUserId
      ? `/cards/credit/ag/${encodedLocalUserId}/${encodedNull}/${encodedNull}/${encodedNull}`
      : "";
    const yearEndPath =
      agentData && agentData.listgenUserID
        ? `/agent/year-end-statement/${agentData.listgenUserID}`
        : "";

    const listgenLogo = (process.env.PUBLIC_URL || '') + "/images/listgen-logo.png";
    const listgenAltLogo = (process.env.PUBLIC_URL || '') + "/images/listgen-text-advanced-v1.png";
    const listgenLogoAlt = "ListGen Logo";
    const rootClassName = classNames(classes.root, className);
    // console.log("******userData2", navbarInfo);
    return (
      <nav className={rootClassName}>
        <div className={classes.drawerHeader}>
          <div className={classes.logoWrapper}>
            <Link className={classes.logoLink} to="/home">
              <img
                alt="ListGen logo"
                className={classes.logoImage}
                src={listgenAltLogo}
              />
            </Link>
          </div>
          <IconButton
            onClick={(event) => handleDrawerClose()}
            color="primary"
            size="small"
          >
            {/* <ChevronLeftIcon />  */}
            Close
          </IconButton>
        </div>
        <Divider className={classes.logoDivider} />
        {/* <div className={classes.profile}>
        </div>
        <Divider className={classes.profileDivider} /> */}
        <List component="div" disablePadding>
          <ListItem
            component={NavLink}
            to="/home"
            selected={this.isPathActive("/home")}
            classes={{
              root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/home") }),
              selected: classes.activeListItem
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Home"
            />
          </ListItem>
          {(!this.isValidLogin && this.isValidSemiLogin) ||
          (this.isValidLogin &&
            !this.isValidSemiLogin &&
            localStateData &&
            localStateData.userRole &&
            isUserAdmin(localStateData.userRole)) ? (
            <Fragment>
              {/* <ListItem
                activeClassName={classes.activeListItem}
                className={classes.listItem}
                component={NavLink}
                to="/pricing"
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <MoneyIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Pricing"
                />
              </ListItem> */}
              {/* <ListItem
                activeClassName={classes.activeListItem}
                className={classes.listItem}
                component={NavLink}
                to="/about"
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="About Us"
                />
              </ListItem> */}
          <ListItem
            component={NavLink}
            to="/schedule"
            selected={this.isPathActive("/schedule")}
            classes={{
              root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/schedule") }),
              selected: classes.activeListItem
            }}
          >
                <ListItemIcon className={classes.listItemIcon}>
                  <CalendarToday />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Mailing Schedule"
                />
              </ListItem>
              <HelpV1Wrapper>
              <ListItem
                className={classes.listItem}
                //component={NavLink}
                //to="/help"
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <ContactSupportIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Support"
                />
              </ListItem>
              </HelpV1Wrapper>
            </Fragment>
          ) : (
            ""
          )}

          {!this.isValidLogin && this.isValidSemiLogin ? (
            <ListItem
              component={NavLink}
              to="/agent/register"
              selected={this.isPathActive("/agent/register")}
              classes={{
                root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/agent/register") }),
                selected: classes.activeListItem
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Register"
              />
            </ListItem>
          ) : (
            ""
          )}

          {this.isValidLogin && !this.isValidSemiLogin ? (
            <Fragment>
              {localStateData &&
              localStateData.userRole &&
              isUserAgent(localStateData.userRole) ? (
                <Fragment>
                   <HelpV1Wrapper>
                  <ListItem
                    className={classes.listItem}
                    //component={NavLink}
                    //to="/help"
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <ContactSupportIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Support"
                    />
                  </ListItem>
                  </HelpV1Wrapper>
                  <ListItem
                    component={NavLink}
                    to={viewPmaPath}
                    selected={this.isPathActive("/pma")}
                    classes={{
                      root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/pma") }),
                      selected: classes.activeListItem
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="View PMA"
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={viewMailProPath}
                    selected={this.isPathActive("/mailpro")}
                    classes={{
                      root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/mailpro") }),
                      selected: classes.activeListItem
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="View MailPro"
                    />
                  </ListItem>
                  <ListItem
                    component={NavLink}
                    to={"/agent/missionstatements"}
                    selected={this.isPathActive("/agent/missionstatements")}
                    classes={{
                      root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/agent/missionstatements") }),
                      selected: classes.activeListItem
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <AdjustIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Mission Statements"
                    />
                  </ListItem>
                  {/*<ListItem
                    activeClassName={classes.activeListItem}
                    className={classes.listItem}
                    component={NavLink}
                    to={`/agent/property-highlights`}
                    classes={{ gutters: classes.listItemGutter }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <HighlightIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Property Highlights"
                    />
                  </ListItem>*/}
                  {/* <ListItem
                    activeClassName={classes.activeListItem}
                    className={classes.listItem}
                    component={NavLink}
                    to={"/agent/mystrengths"}
                    classes={{ gutters: classes.listItemGutter }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <CenterFocusStrongIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Edit Designations"
                    />
                  </ListItem> */}
                  <ListItem
                    component={NavLink}
                    to={"/agent/clienttestimonials"}
                    selected={this.isPathActive("/agent/clienttestimonials")}
                    classes={{
                      root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/agent/clienttestimonials") }),
                      selected: classes.activeListItem
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <FeedbackIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Add Testimonials"
                    />
                  </ListItem>
                </Fragment>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            ""
          )}
        </List>
        {this.isValidLogin || this.isValidSemiLogin ? (
          <Fragment>
            <Divider className={classes.listDivider} />
            <List
              component="div"
              disablePadding
              // subheader={
              //   <ListSubheader className={classes.listSubheader}>
              //     Others
              //   </ListSubheader>
              // }
            >
              {!this.isValidLogin && this.isValidSemiLogin ? (
                <ListItem
                  component={NavLink}
                  to="/legal"
                  selected={this.isPathActive("/legal")}
                  classes={{
                    root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/legal") }),
                    selected: classes.activeListItem
                  }}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <InfoIcon />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.listItemText }}
                    primary="Legal Terms"
                  />
                </ListItem>
              ) : (
                ""
              )}
              {this.isValidLogin && !this.isValidSemiLogin ? (
                <Fragment>
                  <ListItem
                    component={NavLink}
                    to="/account"
                    selected={this.isPathActive("/account")}
                    classes={{
                      root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/account") }),
                      selected: classes.activeListItem
                    }}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="My Account"
                    />
                  </ListItem>
                  {localStateData &&
                  localStateData.userRole &&
                  isUserAgent(localStateData.userRole) ? (
                    <Fragment>
                      <ListItem
                        component={NavLink}
                        to={updateProfilePath || "/agent/details"}
                        selected={this.isPathActive("/agent/details")}
                        classes={{
                          root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/agent/details") }),
                          selected: classes.activeListItem
                        }}
                      >
                        <ListItemIcon className={classes.listItemIcon}>
                          <AccountBoxIcon />
                        </ListItemIcon>
                        <ListItemText
                          classes={{ primary: classes.listItemText }}
                          primary="Update Profile"
                        />
                      </ListItem>
                      <ListItem
                        component={NavLink}
                        to={manageCardsPath || "/cards/credit"}
                        selected={this.isPathActive("/cards/credit")}
                        classes={{
                          root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/cards/credit") }),
                          selected: classes.activeListItem
                        }}
                      >
                        <ListItemIcon className={classes.listItemIcon}>
                          <CreditCardIcon />
                        </ListItemIcon>
                        <ListItemText
                          classes={{ primary: classes.listItemText }}
                          primary="Manage Credit Cards"
                        />
                      </ListItem>
                        {<ListItem
                          component={NavLink}
                          to={`${yearEndPath || "/agent/year-end-statement"}?year=${new Date().getFullYear()}`}
                          selected={this.isPathActive("/agent/year-end-statement")}
                          classes={{
                            root: classNames(classes.listItem, { [classes.activeListItem]: this.isPathActive("/agent/year-end-statement") }),
                            selected: classes.activeListItem
                          }}
                        >
                          <ListItemIcon className={classes.listItemIcon}>
                            <ReceiptIcon />
                          </ListItemIcon>
                          <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary="Year End Statement"
                          />
                        </ListItem>}
                    </Fragment>
                  ) : (
                    <Fragment></Fragment>
                  )}
                  <ListItem
                    className={classes.listItem}
                    onClick={(event) => this.handleSignOut()}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <InputIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Logout"
                    />
                  </ListItem>
                </Fragment>
              ) : (
                ""
              )}
            </List>
          </Fragment>
        ) : (
          ""
        )}
      </nav>
    );
  }
}

Sidebar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

// export default compose(withRouter, withStyles(styles))(Sidebar);

const enhance = compose(withRouter, withStyles(styles));
export default enhance(Sidebar);
